export enum MarketDataEntryType {

    /** IOI bid entry. */
    BID_IOI            = 'BID_IOI',

    /** IOI offer entry. */
    OFFER_IOI          = 'OFFER_IOI',

    /** Order bid entry. */
    BID_ORDER          = 'BID_ORDER',

    /** Order offer entry. */
    OFFER_ORDER        = 'OFFER_ORDER',

    /** Trade entry. */
    TRADE              = 'TRADE',

    /** NBBO/PBBO bid entry. */
    BID_NATIONAL       = 'BID_NATIONAL',

    /** NBBO/PBBO offer entry. */
    OFFER_NATIONAL     = 'OFFER_NATIONAL',

    /** Trading session open price entry. */
    OPENING_PRICE      = 'OPENING_PRICE',

    /** Trading session close price entry. It's last session close price. */
    CLOSING_PRICE      = 'CLOSING_PRICE',

    /** Trading session high price entry. */
    SESSION_HIGH_PRICE = 'SESSION_HIGH_PRICE',

    /** Trading session low price entry. */
    SESSION_LOW_PRICE  = 'SESSION_LOW_PRICE',

    /** Total trade volume */
    SESSION_VOLUME     = 'SESSION_VOLUME',

    /** Funding Rate */
    FUNDING_RATE       = 'FUNDING_RATE',

    /**
     * Option chain specific entries
     */
    BID_IV             = 'BID_IV',
    GREEKS_DELTA       = 'GREEKS_DELTA',
    GREEKS_GAMMA       = 'GREEKS_GAMMA',
    GREEKS_RHO         = 'GREEKS_RHO',
    GREEKS_THETA       = 'GREEKS_THETA',
    GREEKS_VEGA        = 'GREEKS_VEGA',
    MARK_PRICE         = 'MARK_PRICE',
    OFFER_IV           = 'OFFER_IV',
    OPEN_INTEREST      = 'OPEN_INTEREST'
}

export enum MarketDataUpdateAction {
    NEW    = 'NEW',
    DELETE = 'DELETE',
    CHANGE = 'CHANGE'
}
